import React, { useState } from "react";
import VidPlayIcon from "@atlaskit/icon/core/video-play-overlay";
import Button from "@atlaskit/button/new";
import TestFlowModal from "./TestFlowModal";
import { useSelector } from "react-redux";

const TestFlowButton = () => {
  const [isOpen, setOpen] = useState(false);
  const flow = useSelector((state) => state.integration.flow);
  const openRunFlowModal = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Button onClick={openRunFlowModal} isDisabled={!flow.enabled}>
        <VidPlayIcon label="Start" color="#00875a" />
      </Button>
      <TestFlowModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};
export default TestFlowButton;
